import { motion } from "framer-motion";
import { useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import buyTokenIcon from "../../assets/buy_token_line.png";
import createWalletIcon from "../../assets/create_wallet_line.png";
import grabSolIcon from "../../assets/grab_sol_line.png";
import knifeImage from "../../assets/knife.png";
import openRadiumIcon from "../../assets/open_radium_line.png";
import StepCard from "../../Components/StepCard/StepCard";
import './HowToBuySection.css';

function HowToBuySection() {
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 768);

  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const steps = [
    {
      icon: createWalletIcon,
      title: "Create a Wallet",
      className: "card1",
      description: "Download the Phantom Wallet app or Your preferred wallet from the app store or Google Play Store at no cost. If your using a desktop, obtain the Google Chrome extension by visiting Phantom App"
    },
    {
      icon: grabSolIcon,
      title: "Grab Some Sol",
      className: "card2",
      description: "Transfer Fund to Exchange and then into your Platform Wallet via SOL Network"
    },
    {
      icon: openRadiumIcon,
      title: "Open Radium",
      className: "card3",
      description: "Click Select a Currency enter the Contract into the search field copy Contract Address"
    },
    {
      icon: buyTokenIcon,
      title: "Buy Token",
      className: "card4",
      description: "Set the desire Slippage, Click 'buy' and be prepared to adjust the slippage during times of market volatility if necessary"
    }
  ];

  return (
    <section className="how-to-buy-section" id="howToBuy">
      <Container>
        <motion.h1
          initial={{ opacity: 0, y: -50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          once={true}
        >
          How To Buy
        </motion.h1>
        <div className="steps-container">
          <motion.div
            className="knife-container"
            initial={{ opacity: 0, scale: 0 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, delay: 0.3 }}
            once={true}
          >
            <img src={knifeImage}
              alt="knifeImage"
              className="knife-image"
            />
          </motion.div>
          <Row className="justify-content-between">
            {steps.map((step, index) => (
              <Col key={index} md={6}>
                <motion.div
                  initial={{ opacity: 0, y: isMobile ? 50 : 0, x: isMobile ? 0 : (index % 2 === 0 ? -100 : 100) }}
                  whileInView={{ opacity: 1, y: 0, x: 0 }}
                  transition={{ duration: isMobile ? 0.3 : 0.8, delay: isMobile ? 0.1 : (0.8 + index * 0.2) }}
                  once={true}
                  viewport={{ margin: isMobile ? "-50px" : "0px" }}
                >
                  <StepCard {...step} />
                </motion.div>
              </Col>
            ))}
          </Row>
        </div>
      </Container>
    </section>
  );
}

export default HowToBuySection;
